import { MODAL_INITIAL_FOCUS_ATTR } from "@faire/slate/private/modal/consts";

const NATURALLY_FOCUSABLE_SELECTOR =
  "button, input, select, textarea, a[href], area[href], summary, [tabindex]";

const isNaturallyFocusable = (element: HTMLElement): boolean =>
  element.matches(NATURALLY_FOCUSABLE_SELECTOR);

const getFirstLabelledById = (
  labelledBy: string | null | undefined
): string | null => {
  const trimmed = labelledBy?.trim();
  if (!trimmed) {
    return null;
  }
  const firstId = trimmed.split(/\s+/)[0];
  return firstId ?? null;
};

export const resolveModalInitialFocusElement = (
  floatingElement: HTMLElement | null
): HTMLElement | null => {
  const slotTarget = floatingElement?.querySelector<HTMLElement>(
    `[${MODAL_INITIAL_FOCUS_ATTR}]`
  );
  if (slotTarget) {
    return slotTarget;
  }

  const labelledById = getFirstLabelledById(
    floatingElement?.getAttribute("aria-labelledby")
  );

  if (!labelledById) {
    return null;
  }

  const element = document.getElementById(labelledById);
  return element instanceof HTMLElement ? element : null;
};

export const focusModalInitialElement = (element: HTMLElement): void => {
  if (!isNaturallyFocusable(element) && !element.hasAttribute("tabindex")) {
    element.tabIndex = -1;
  }
  element.focus({ preventScroll: true });
};
